import { useEffect, useState, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { authApi } from "../api/auth";

/**
 * UI-only gate: hides admin routes from non-admins in the nav and bounces
 * them home. Not the real security boundary — every /api/admin/* route
 * enforces `require_admin` server-side regardless of what this renders.
 */
export default function AdminGate({ children }: { children: ReactNode }) {
  const [status, setStatus] = useState<"checking" | "admin" | "denied">("checking");

  useEffect(() => {
    let cancelled = false;
    authApi
      .me()
      .then((u) => {
        if (!cancelled) setStatus(u.role === "admin" ? "admin" : "denied");
      })
      .catch(() => {
        if (!cancelled) setStatus("denied");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "checking") return null;
  if (status === "denied") return <Navigate to="/" replace />;
  return <>{children}</>;
}
